import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
		
gsap.registerPlugin(ScrollTrigger);
		

const animateHashtag =  {
    init() {

        if(window.innerWidth < 992) {
            return;
        }

        let hashtags = document.querySelectorAll('.js-hashtags > div');
        let self = this;

        if (! hashtags) {
            return;
        }

        if(hashtags.length > 1) {
            self._animate(hashtags);
        }
    },

    _animate(hashtags) {
        let self = this;

        gsap.to(hashtags, {
            duration: 0.3,
            autoAlpha: 1,
            ease: "power1.inOut",
            stagger: 1
          });
    }
};

const animateSlider =  {
    init() {

        if(window.innerWidth < 992) {
            return;
        }

        let slider = document.querySelector('.js-slider');
        let self = this;

        if (! slider) {
            return;
        }

        self._animate(slider);
    },

    _animate(slider) {
        gsap.to(slider, {
            duration: 0.4,
            autoAlpha: 1,
            x: 0,
            ease: "power1.inOut",
          });
    }
};


const animateArticles =  {
    init() {

        if(window.innerWidth < 992) {
            return;
        }

        let articlePreviews = document.querySelectorAll('.js-article-preview .article-preview');
        let self = this;

        if (! articlePreviews) {
            return;
        }

        if (articlePreviews.length > 1) {
            self._animate(articlePreviews);
        }
    },

    _animate(articlePreviews) {

        let tl = gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
              trigger: ".js-article-preview",
              start: "top 70%", // when the top of the trigger hits the top of the viewport
              end: "+=500", // end after scrolling 500px beyond the start
            }
          });

          tl.from(articlePreviews, {duration: 0.4, y: 50, autoAlpha: 0, stagger: 0.1});
    }
};

const animateArticlesImg =  {
    init() {
        let articlePreviews = document.querySelectorAll('.article-preview-img');
        let self = this;
    
        if(window.innerWidth < 992) {
            return;
        }

        if (! articlePreviews) {
            return;
        }

        if (articlePreviews.length > 1) {
            self._animate(articlePreviews);
        }
    },

    _animate(articlePreviews) {

        let tl = gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
              trigger: ".js-article-preview-img",
              start: "top 70%", // when the top of the trigger hits the top of the viewport
              end: "+=500", // end after scrolling 500px beyond the start
            }
          });

          tl.from(articlePreviews, {duration: 0.4, y: 50, autoAlpha: 0, stagger: 0.1});
    }
};

document.addEventListener('bodyLoadingFinished', function () {    
    animateSlider.init();
    animateHashtag.init();
    animateArticles.init();
    animateArticlesImg.init();
});